import * as React from 'react';
import { PlayStateEnum } from '../interfaces/state';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';
import { OnIgnoreEnter } from '../AnalyseApp';

interface PlayPauseProps {
    isLoading: boolean;
    isPlaying: PlayStateEnum;
    isKeyboardShortcutVisible: boolean;
    onPlayClick: () => void;
    onPauseClick: () => void;
}

export const PlayPause = (props: PlayPauseProps) => {
    if (props.isLoading) {
        return (
            <button id="Playback" className="btn btn-primary" disabled>
                <i className="fas fa-circle-notch fa-spin fa-fw" aria-hidden="true"></i>&nbsp;
                Loading
            </button>
        );
    } else if (props.isPlaying == PlayStateEnum.Playing) {
        return (
            <button id="Playback" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); props.onPauseClick() }} onKeyDown={OnIgnoreEnter}>
                <i className="fas fa-pause" aria-hidden="true"></i>
                <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="SPACE" />
            </button>
        );
    } else if (props.isPlaying == PlayStateEnum.NotStarted || props.isPlaying == PlayStateEnum.Paused) {
        return (
            <button id="Playback" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); props.onPlayClick() }} onKeyDown={OnIgnoreEnter}>
                <i className="fas fa-play" aria-hidden="true"></i>
                <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="SPACE" />
            </button>
        );
    } else {
        return null;
    }
}
